const Modal = ({ show, message, onClose, actionLabel, onAction }) => {
    if (!show) return null;

    return (
        <div className="universalModalOverlay" >
            <div className="universalModal">
                <p>{message}</p>
                <div className="universalModalButtons">
                    {onAction && (
                        <button className="baseButton" onClick={onAction}>{actionLabel || "OK"}</button>
                    )}
                    <button className="baseButton" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
};

export default Modal;